import { IEVersion, filterUrl } from '@/utils'
import CONFIG from '@/config'
import STORE from '@/store'
import { SELECTED_HOTSPOT } from '@/config/contant'

const Install = function(Vue) {
  const krPlugin = new Vue({
    data() {
      return {
        baseUrl: window.$globalconfig.URLS.API,
        krpano: null,
        duration: 0,
        hotspotList: [],
      }
    },
    computed: {
      getVideoReady() {
        return this.krpano.get('plugin[videoscene].isvideoready')
      },
      isVideoPaused() {
        return this.krpano.get('plugin[videoscene].ispaused')
      },
    },
    methods: {
      initKrplugin(krpano) {
        this.krpano = krpano
      },
      changeVideo(sceneId, url) {
        STORE.dispatch('CLEAR_SCENE_HOTSPOTS')
        this.clearHotspotFormScene()
        this.krpano.call(`plugin[videoscene].playvideo(${url})`)
        setTimeout(() => {
          STORE.dispatch('VIDEO_SCENE_HOTSPOTS', sceneId)
        }, 100)
      },
      getVideoTotalTime() {
        return this.krpano.get('plugin[videoscene].totaltime')
      },
      getVideoTime() {
        return this.krpano.get('plugin[videoscene].time')
      },
      setVideoTime(time) {
        this.krpano.set('plugin[videoscene].time', time)
      },
      setVideoVolume(val) {
        this.krpano.set('plugin[videoscene].volume', val)
      },
      setVideoFullScreen() {
        this.krpano.call('switch(fullscreen)')
      },
      playVideo() {
        this.krpano.call('plugin[videoscene].play')
      },
      pauseVideo() {
        this.krpano.call('plugin[videoscene].pause')
      },
      getGyroStatus() {
        return this.krpano.get('plugin[skin_gyro].enabled')
      },
      toggleGyro() {
        this.krpano.call('click_gyro()')
      },
      setVrModal() {
        this.krpano.call('click_openVR()')
      },
      getVideoStatus() {
        return this.krpano.get('plugin[videoscene].pausedonstart')
      },
      showVideoHotspot(hotId) {
        this.krpano.set('hotspot[hotspot_' + hotId + '].visible', true)
      },
      hideVideoHotspot(hotId) {
        this.krpano.set('hotspot[hotspot_' + hotId + '].visible', false)
      },
      getSceneData(str) {
        return this.krpano.get(str)
      },
      callScene(str) {
        this.krpano.call(str)
      },
      lookTo(obj) {
        this.callScene(`lookto(${obj.ath},${obj.atv})`)
      },
      showVR() {
        this.callScene('webvr.enterVR();onshowVRhot();')
      },
      // 隐藏VR
      hideVR() {
        this.callScene('webvr.exitVR();hidehotspot_enterVR();')
      },
      getCurPos() {
        let ath = Number(this.getSceneData('view.hlookat')).toFixed(2)
        let atv = Number(this.getSceneData('view.vlookat')).toFixed(2)
        let fov = this.getSceneData('view.fov')

        return {
          fov,
          ath,
          atv,
        }
      },
      getSceneName() {
        return this.krpano.get('scene[get(xml.scene)].name')
      },
      getSceneId() {
        return this.getSceneName().split('_')[1]
      },
      setScene(prop, val) {
        this.krpano.set(prop, val)
      },
      setProperty(prop, val) {
        this.setScene(`hotspot[get(hotspotid)].${prop}`, val)
      },
      setPropertyByID(hotId, prop, val) {
        this.setScene(`hotspot[hotspot_'${hotId}].${prop}`, val)
      },
      delHotspot(hotId) {
        const hotspotList = this.hotspotList
        if (hotId) {
          hotspotList.map((it, idx) => {
            if (it.hot_id === hotId) {
              this.krpano.call(`removehotspot(hotspot_${hotId})`)
            }
          })
        } else {
          hotspotList.map(it => {
            this.krpano.call(`removehotspot(hotspot_${it.hot_id})`)
          })
        }
      },
      delHotspotFormScene(hotId) {
        this.delHotspot(hotId)
      },
      clearHotspotFormScene() {
        this.delHotspot()
      },
      addHotspotToScene(hotspotList) {
        this.hotspotList = hotspotList
        hotspotList.map(it => {
          const dataStrObj = JSON.parse(it.datastr)

          it.krname = {
            name: 'hotspot_' + it.hot_id,
            ath: it.ath,
            atv: it.atv,
            diy_id: it.diy_id,
            type_id: it.type_id,
            hot_name: it.hot_name,
            fk_user_id: it.fk_user_id,
            starttime: it.starttime,
            endtime: it.endtime,
            url: filterUrl(dataStrObj.cover),
            scale: dataStrObj.scale,
            distorted: true,
            visible: false,
            onclick: this.onHotspotClick,
            ondown:
              'set(hotspotid, hotspot_' +
              it.hot_id +
              ');set(sceneid, ' +
              it.scene_id +
              ')',
            onup: this.onHotspotUp,
          }

          if (it.starttime === 0) {
            it.krname.visible = true
          }

          this.krpano.call('addhotspot(' + it.krname.name + ')')
          let hasName = it.hot_name === '' ? '' : 'add_tooltip()'
          // let onLoadedVal = `hotspot_animate()${hasName}`

          // GIF图标
          if (CONFIG.roamHotspotId === it.type_id) {
            it.krname = Object.assign({}, it.krname, {
              text: it.hot_name + '',
              crop: it.crop,
              type: 'image',
              keep: 'false',
              enabled: 'true',
              edge: 'bottom',
              bgcapture: true,
              ishotspot: true,
              handcursor: true,
              lastframe: 'normal',
              onloaded: hasName,
            })
          }

          // 图片
          if (CONFIG.imageHotspotId === it.type_id) {
            it.krname = Object.assign({}, it.krname, {
              width: dataStrObj.width,
              height: dataStrObj.height,
            })
          }

          // 视频
          if (CONFIG.videoHotspotId === it.type_id) {
            // 如果是IE
            if (IEVersion() === '-1') {
              it.krname = Object.assign({}, it.krname, {
                url: `${this.baseUrl}krpano/plugins/videoplayer.js`,
              })
            } else {
              it.krname = Object.assign({}, it.krname, {
                videourl: dataStrObj.url && filterUrl(dataStrObj.url),
                url: `${this.baseUrl}krpano/plugins/videoplayer.js`,
                posterurl: `${this.baseUrl}krpano/images/vdplay.png`,
                width: dataStrObj.width,
                height: dataStrObj.height,
                rx: dataStrObj.rx,
                ry: dataStrObj.ry,
                rotate: dataStrObj.rotate,
                edge: 'center',
                loop: 'true',
                pausedonstart: 'flase',
                onclick: `js(console.log("abcd"));togglepause();`,
              })
            }
          }
          for (let k in it.krname) {
            let val = it.krname[k]
            let key = k
            this.krpano.set('hotspot[' + it.krname.name + '].' + key, val)
          }

          it.krname = null
        })
      },
      onHotspotClick() {
        let hotId = Number(this.getSceneData('hotspotid').split('_')[1])
        if (!hotId) return
        // 热点编辑
        this.hotspotList.map((item, idx) => {
          if (item.hot_id === hotId) {
            this.$vgo.emit(SELECTED_HOTSPOT, { index: idx, data: item })
          }
        })
      },
      onHotspotUp() {},
    },
  })
  Vue.prototype.$krp = krPlugin
}

export default Install
